import { Component, OnInit } from '@angular/core';
import { Title } from '@angular/platform-browser';
import { ActivatedRoute, Router } from '@angular/router';
import { NgbModal } from '@ng-bootstrap/ng-bootstrap';
import { TranslateService } from '@ngx-translate/core';
import { CookieService } from 'ngx-cookie-service';
import { BaseRichService } from '../../../providers/base-rich.service';
import { ListComponent } from '../../shared/list/list.component';

@Component({
  selector: 'app-transaction-list',
  templateUrl: '../../shared/base-list/base-list.component.html',
  styleUrls: ['./transaction-list.component.scss', '../../shared/base-list/base-list.component.scss']
})
export class TransactionListComponent extends ListComponent implements OnInit {

  constructor(
    public cookieService: CookieService,
    public activeModal: NgbModal,
    public titleService: Title,
    public translator: TranslateService,
    public service: BaseRichService,
    public route: ActivatedRoute,
    public router: Router
  ) {
    super(cookieService, activeModal, titleService, translator, service, route, router);
    this.title = 'transactions';
    this.entity = 'transaction';
  }

}
